module.exports = __webpack_public_path__ + "static/media/signout.ebf7e372.svg";